import { render, staticRenderFns } from "./DetailPromos.vue?vue&type=template&id=5a302dab&scoped=true"
import script from "./DetailPromos.vue?vue&type=script&lang=js"
export * from "./DetailPromos.vue?vue&type=script&lang=js"
import style0 from "./DetailPromos.vue?vue&type=style&index=0&id=5a302dab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a302dab",
  null
  
)

export default component.exports